import EditableShape from '@recogito/annotorious/src/tools/EditableShape';
import { SVG_NAMESPACE, addClass, hasClass, removeClass } from '@recogito/annotorious/src/util/SVG';
import { format, setFormatterElSize } from '@recogito/annotorious/src/util/Formatting';
import { svgFragmentToShape } from '@recogito/annotorious/src/selectors/EmbeddedSVG';
import { pointInPolygon } from '@recogito/annotorious/src/util/Geom2D';

import { toSVGTarget, getPath } from './RubberbandSegmentAnythingTool';

const getPointsFromPathValue = polygon => {
  const allcoords = [];

  const parts = polygon
    .split("M")
    .map(part => part.trim())
    .filter(Boolean);

  parts.forEach(part => {
    const coords = [];

    const cleaned = part
      .replace(/Z/g, "")
      .trim();

    const segments = cleaned
      .split("L")
      .map(seg => seg.trim())
      .filter(Boolean);

    segments.forEach(segment => {
      const [x, y] = segment.split(",");

      coords.push([
        parseFloat(x).toFixed(2),
        parseFloat(y).toFixed(2)
      ]);
    });

    if (
      coords.length > 0 &&
      (
        coords[0][0] !== coords[coords.length - 1][0] ||
        coords[0][1] !== coords[coords.length - 1][1]
      )
    ) {
      coords.push([...coords[0]]);
    }

    allcoords.push(coords);
  });

  return allcoords;
};

export const getPoints = (shape) => {
  // Could just be Array.from(shape.querySelector('.inner').points) but...
  // IE11 :-(

  const pointLists = getPointsFromPathValue(shape.querySelector('.a9s-inner').attributes.d.nodeValue)
  const pointArray = [];
  for (let pointList of pointLists) {
    let points = []
    for (let point of pointList) {
      let p = {
        x:parseFloat(point[0]),
        y:parseFloat(point[1])
      }
      points.push(p);
    }
    pointArray.push(points)
  }
  return pointArray;
}

const getBBox = shape => {
  return shape.querySelector('.a9s-inner').getBBox();
}
export const svgFragmentToPoints = annotation => {

  const svgShape = svgFragmentToShape(annotation);

  var polygon = svgShape.getAttribute('d')
  console.log("polygon", polygon);

  var allcoords =  getPointsFromPathValue(polygon)
  console.log("svgFragmentToPoints allcoords", allcoords);

  return allcoords
}

const drawEmbeddedSVG = annotation => {
  console.log("drawEmbeddedSVG", annotation);

  const shape = svgFragmentToShape(annotation);
  console.log("drawEmbeddedSVG shape", shape);

  // Hack
  svgFragmentToPoints(annotation);
  console.log("svgFragmentToPoints done");

  // Because we're nitpicky, we don't just draw the shape,
  // but duplicate it, so we can have inner and an outer lines
  const g = document.createElementNS(SVG_NAMESPACE, 'g');

  const inner = shape.cloneNode(true);
  inner.setAttribute('class', 'a9s-inner');

  const outer = shape.cloneNode(true);
  outer.setAttribute('class', 'a9s-outer');

  g.appendChild(outer);
  g.appendChild(inner);
  return g;
}

export default class EditableSegmentAnything extends EditableShape {

  constructor(annotation, g, config, env) {
    super(annotation, g, config, env);
    this.svg.addEventListener('mousedown', this.onMouseDown, true);
    this.svg.addEventListener('mousemove', this.onMouseMove);
    this.svg.addEventListener('mouseup', this.onMouseUp);
    this.svg.addEventListener('contextmenu', this.onContextMenu, true);
    document.addEventListener('mousedown', this.onDocumentMouseDown, true);
    document.addEventListener('pointerdown', this.onDocumentPointerDown, true);
    document.addEventListener('contextmenu', this.onDocumentContextMenu, true);
    // This part is added to track time of annotation process. It is not confirm with W3C-Annotations
    if (!this.annotation.underlying["generated"]){
      console.log("generated", this.annotation.segmentAnything.started);
      this.annotation.underlying["generated"] = Date.now()
      this.annotation.underlying.target.renderedVia = "segmentanything";
      this.annotation.underlying["started"] = this.annotation.segmentAnything.started
    }
    document.body.addEventListener('keydown', this.onKeyDown);

    // Container wraps the mask + editable shape
    this.container = document.createElementNS(SVG_NAMESPACE, 'g');

    // The editable shape group
    console.log("drawEmbeddedSVG", annotation);

    this.shape = drawEmbeddedSVG(annotation);
    console.log("constructor editableSegmentAnything this.shape", this.shape);

    this.shape.setAttribute('class', 'a9s-annotation editable selected segment-anything');
    this.elementGroup = document.createElementNS(SVG_NAMESPACE, 'g');
    this.elementGroup.setAttribute('class', 'a9s-annotation editable selected segment-anything');
    this.elementGroup.appendChild(this.shape);
    let cornerList = getPoints(this.shape);
    this.cornerHandles = []
    this.midpoints = []
    for (let corners of cornerList){
      let midpoints = []
      this.cornerHandles.push(corners.map((pt, idx) => {
        midpoints.push(this.createMidpoint(corners, idx));
        const handle = this.createCornerHandle(pt);
        return handle;
      }))
      this.midpoints.push(midpoints);
    }
    this.container.appendChild(this.elementGroup)
    g.appendChild(this.container);
    // Format needs to go after everything is added to the DOM
    format(this.shape, annotation, config.formatter);
    this.shape.querySelector('.a9s-inner')
      .addEventListener('mousedown', this.onGrab(this.shape));

    // Grabbed element and grab offset
    this.grabbedElement = null;
    this.grabbedAt = null;

    // Selected corners
    this.selected = [];

    this.lastMouseDown = null;
    this.selectionBox = null;
    this.selectionStart = null;
  }

  createCornerHandle = pt => {
    const handle = this.drawHandle(pt.x, pt.y);
    handle.setAttribute('tabindex', '-1');
    handle.addEventListener('mousedown', this.onGrab(handle));
    handle.addEventListener('click', this.onSelectCorner(handle));
    handle.addEventListener('keydown', (evt) => {
      console.log("createCornerHandle keydown", evt);
        if (evt.key === 'd') {
          evt.preventDefault();
          this.deleteSelected();
        }
      });
    this.scaleHandle(handle);

    this.elementGroup.appendChild(handle);
    return handle;
  }

  createMidpoint = (corners, idx) => {
    // Create point between this and previous corner
    const thisCorner = corners[idx];
    const nextCorner = idx === corners.length - 1 ? corners[0] : corners[idx + 1];
    const x = (thisCorner.x + nextCorner.x) / 2;
    const y = (thisCorner.y + nextCorner.y) / 2;
    const handle = this.drawMidpoint(x, y);
    handle.addEventListener('mousedown', this.onGrab(handle));

    this.shape.appendChild(handle);
    return handle;
  }
  initiateSmoothingOfPoints(startCorner, endCorner) {
    const points = getPoints(this.shape);
    startIDX = this.cornerHandles.indexOf(startCorner);
    endIDX = this.cornerHandles.indexOf(endCorner);
    smoothingPoints = points.slice(startIDX, endIDX + 1);
    const smoothedPoints = this.smoothPoints(smoothingPoints, 5, 0.5);
    newPoints = points.slice(0, startIDX).concat(smoothedPoints).concat(points.slice(endIDX + 1));
    setPoints(this.shape, smoothedPoints);
  }
  /**
   * Smooths a list of points by taking the average of the surrounding points
   * within a given window size and then moving the original point towards the
   * average by a given alpha value.
   *
   * @param {Array} points - The list of points to be smoothed
   * @param {Number} [windowSize=5] - The size of the window for taking the average
   * @param {Number} [alpha=0.5] - The amount of smoothing to apply
   * @return {Array} The smoothed points
   */
  smoothPoints(points, windowSize = 5, alpha = 0.5) {
    const smoothedPoints = [];

    for (let i = 0; i < points.length; i++) {
      let xSum = 0, ySum = 0, count = 0;

      // Calculate the average of the surrounding points
      for (let j = -Math.floor(windowSize / 2); j <= Math.floor(windowSize / 2); j++) {
        const index = i + j;

        if (index >= 0 && index < points.length) {
          xSum += points[index][0];
          ySum += points[index][1];
          count++;
        }
      }

      const avgX = xSum / count;
      const avgY = ySum / count;

      // Move the original point towards the average
      const [origX, origY] = points[i];
      const newX = origX + alpha * (avgX - origX);
      const newY = origY + alpha * (avgY - origY);

      smoothedPoints.push([newX, newY]);
    }

    return smoothedPoints;
  }
deleteSelected = () => {
    if (this.selected.length === 0) return;

    // 1. Daten bereinigen: Die neuen Arrays ohne die gelöschten Punkte aufbauen
    const allPolygonPoints = getPoints(this.shape);
    let newPolygonPoints = [];

    allPolygonPoints.forEach((poly, polyIdx) => {
        let newPoly = poly.filter((pt, ptIdx) => {
            return !this.selected.some(sel => sel[0] === polyIdx && sel[1] === ptIdx);
        });

        // Polygon nur behalten, wenn es noch eine Fläche bilden kann (mindestens 3 Punkte)
        if (newPoly.length > 2) {
            newPolygonPoints.push(newPoly);
        }
    });

    // 2. ALTES UI AUFRÄUMEN: Alles aus dem DOM entfernen
    this.cornerHandles.forEach(list => list.forEach(h => h.remove()));
    this.midpoints.forEach(list => list.forEach(h => h.remove()));

    // Arrays komplett zurücksetzen
    this.cornerHandles = [];
    this.midpoints = [];
    this.selected = [];

    // 3. NEUES UI AUFBAUEN: Wir erstellen die Handles direkt neu an den verbleibenden Koordinaten
    newPolygonPoints.forEach((poly) => {
        // Erstellt die neuen Corner-Handles und pusht sie als Array ins Array
        const handles = poly.map(pt => this.createCornerHandle(pt));
        this.cornerHandles.push(handles);

        // Erstellt die neuen Midpoints
        const mids = poly.map((pt, idx) => this.createMidpoint(poly, idx));
        this.midpoints.push(mids);
    });

    // 4. PFAD MANUELL UPDATEN (Wir umgehen setPoints absichtlich!)
    const str = getPath(newPolygonPoints);
    const inner = this.shape.querySelector('.a9s-inner');
    const outer = this.shape.querySelector('.a9s-outer');

    inner.setAttribute('d', str);
    outer.setAttribute('d', str);

    // Bounding Box für Formatierer/CSS anpassen
    const { x, y, width, height } = outer.getBBox();
    setFormatterElSize(this.shape, x, y, width, height);

    // 5. Annotorious über das Update informieren
    var target = toSVGTarget(newPolygonPoints, this.env.image)
    target.renderedVia = this.annotation.renderedVia || "segmentanything";
    this.emit('update', target);
  }
  deselectCorners = () =>
    this.cornerHandles.forEach(h => removeClass(h, 'selected'));

  destroy = () => {
    this.container.parentNode.removeChild(this.container);

    this.svg.removeEventListener('mousedown', this.onMouseDown, true);
    this.svg.removeEventListener('mousemove', this.onMouseMove);
    this.svg.removeEventListener('mouseup', this.onMouseUp);
    this.svg.removeEventListener('contextmenu', this.onContextMenu, true);
    document.removeEventListener('mousedown', this.onDocumentMouseDown, true);
    document.removeEventListener('pointerdown', this.onDocumentPointerDown, true);
    document.removeEventListener('mousemove', this.onDocumentMouseMove, true);
    document.removeEventListener('mouseup', this.onDocumentMouseUp, true);
    document.removeEventListener('pointermove', this.onDocumentPointerMove, true);
    document.removeEventListener('pointerup', this.onDocumentPointerUp, true);
    document.removeEventListener('contextmenu', this.onDocumentContextMenu, true);

    document.body.removeEventListener('keydown', this.onKeyDown);

    super.destroy();
  }

  drawMidpoint = (x, y) => {
    const handle = document.createElementNS(SVG_NAMESPACE, 'circle');
    handle.setAttribute('class', 'a9s-midpoint');

    handle.setAttribute('cx', x);
    handle.setAttribute('cy', y);
    handle.setAttribute('r', 5 * this.scale);

    return handle;
  }

  get element() {
    return this.elementGroup;
  }

  onAddPoint = pos => {
    const corners = getPoints(this.shape);
    let idx = -1
    let midpointsIDX = -1
    for (let midpointList of this.midpoints){
      midpointsIDX += 1
      idx = midpointList.indexOf(this.grabbedElement);
      if (idx > -1){
        break;
      }
    }
    // Updated polygon points
    let updatedCorners = []
    let updatedcornerListIdx = -1
    let midBefore = null
    let midAfter = null
    for (let cornerList of corners){
      updatedcornerListIdx +=1
      if (updatedcornerListIdx === midpointsIDX){
        let updatedCornersList = []
        let updatedcornerIdx = -1
        for (let corner of cornerList){
          updatedcornerIdx += 1
          updatedCornersList.push(corner)
          if (updatedcornerIdx === idx){
            updatedCornersList.push(pos)
            midBefore = this.createMidpoint(cornerList, updatedcornerIdx -1);
            midAfter = this.createMidpoint(cornerList, updatedcornerIdx);
          }
        }
        updatedCorners.push(updatedCornersList)
      } else {
        updatedCorners.push(cornerList)
      }

    }

    // New corner handle
    const cornerHandle = this.createCornerHandle(pos);
    this.cornerHandles[midpointsIDX] = [
      ...this.cornerHandles[midpointsIDX].slice(0, idx+1),
      cornerHandle,
      ...this.cornerHandles[midpointsIDX].slice(idx+1)
    ];
    this.midpoints[midpointsIDX] = [
      ...this.midpoints[midpointsIDX].slice(0, idx),
      midBefore,
      midAfter,
      ...this.midpoints[midpointsIDX].slice(idx + 1)
    ];
    // Delete old midpoint
    this.grabbedElement.parentNode.removeChild(this.grabbedElement);

    // Make the newly created corner dragged element + selection
    this.grabbedElement = cornerHandle;
    //this.onSelectCorner(cornerHandle)();

    // Update shape
    this.setPoints(updatedCorners);
  }

  onGrab = element => evt => {
    console.log("onGrab", element, evt);

    if (evt.button !== 0) return;  // left click

    if (evt.shiftKey && element === this.shape) {
      this.startBoxSelection(evt);
      return;
    }

    evt.stopPropagation();

    this.grabbedElement = element;
    this.grabbedAt = this.getSVGPoint(evt);
    this.lastMouseDown = new Date().getTime();
  }

  onKeyDown = (evt) => {
    // 1. Prüfen, ob wir gerade in einem Formularfeld tippen
    const activeEl = document.activeElement;
    const isEditing = activeEl && (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA' || activeEl.isContentEditable);

    // 2. Wir prüfen nur noch auf die Taste 'd' und ob wir nicht gerade tippen
    if (evt.key === 'd' && !isEditing) {
      console.log("delete selected wird jetzt aufgerufen!");
      this.deleteSelected();
    }
  }

  onMouseDown = evt => {
    const isBoxSelection = evt.button === 2 || (evt.button === 0 && evt.shiftKey);

    if (!isBoxSelection)
      return;

    if (evt.target.closest?.('.a9s-handle, .a9s-midpoint'))
      return;

    if (evt.button === 0 && evt.target.closest?.('.a9s-inner') && !evt.shiftKey)
      return;

    this.startBoxSelection(evt);
  }

  onDocumentMouseDown = evt => {
    const isBoxSelection = evt.button === 2 || (evt.button === 0 && evt.shiftKey);

    if (!isBoxSelection || this.selectionBox)
      return;

    if (evt.target.closest?.('.a9s-handle, .a9s-midpoint'))
      return;

    const bounds = this.svg.getBoundingClientRect();

    if (
      evt.clientX < bounds.left ||
      evt.clientY < bounds.top ||
      evt.clientX > bounds.right ||
      evt.clientY > bounds.bottom
    ) {
      return;
    }

    this.startBoxSelection(evt);
  }

  onDocumentPointerDown = evt => {
    const isBoxSelection = evt.button === 2 || (evt.button === 0 && evt.shiftKey);

    if (!isBoxSelection || this.selectionBox || !this.isInsideSVG(evt))
      return;

    if (evt.target.closest?.('.a9s-handle, .a9s-midpoint'))
      return;

    this.startBoxSelection(evt);
  }

  onContextMenu = evt => {
    if (this.selectionBox || evt.button === 2) {
      this.stopOSDDrag(evt);
    }
  }

  onDocumentContextMenu = evt => {
    if (this.selectionBox || this.isInsideSVG(evt)) {
      this.stopOSDDrag(evt);
    }
  }

  isInsideSVG = evt => {
    const bounds = this.svg.getBoundingClientRect();

    return (
      evt.clientX >= bounds.left &&
      evt.clientY >= bounds.top &&
      evt.clientX <= bounds.right &&
      evt.clientY <= bounds.bottom
    );
  }

  stopOSDDrag = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation?.();
  }

  getEventSVGPoint = evt => {
    const pt = this.svg.createSVGPoint();

    pt.x = evt.clientX;
    pt.y = evt.clientY;

    return pt.matrixTransform(this.g.getScreenCTM().inverse());
  }

  startBoxSelection = evt => {
    this.stopOSDDrag(evt);

    this.grabbedElement = null;
    this.grabbedAt = null;
    this.selectionStart = this.getEventSVGPoint(evt);

    this.selectionBox = document.createElementNS(SVG_NAMESPACE, 'rect');
    this.selectionBox.setAttribute('class', 'a9s-selection-box');
    this.selectionBox.setAttribute('x', this.selectionStart.x);
    this.selectionBox.setAttribute('y', this.selectionStart.y);
    this.selectionBox.setAttribute('width', 0);
    this.selectionBox.setAttribute('height', 0);

    this.elementGroup.appendChild(this.selectionBox);

    document.addEventListener('mousemove', this.onDocumentMouseMove, true);
    document.addEventListener('mouseup', this.onDocumentMouseUp, true);
    document.addEventListener('pointermove', this.onDocumentPointerMove, true);
    document.addEventListener('pointerup', this.onDocumentPointerUp, true);
  }

  updateBoxSelection = pos => {
    const x = Math.min(this.selectionStart.x, pos.x);
    const y = Math.min(this.selectionStart.y, pos.y);
    const width = Math.abs(pos.x - this.selectionStart.x);
    const height = Math.abs(pos.y - this.selectionStart.y);

    this.selectionBox.setAttribute('x', x);
    this.selectionBox.setAttribute('y', y);
    this.selectionBox.setAttribute('width', width);
    this.selectionBox.setAttribute('height', height);

    const selected = [];

    this.cornerHandles.forEach((handles, cornerIdx) => {
      handles.forEach((handle, idx) => {
        const pt = this.getHandleXY(handle);

        if (
          pt.x >= x &&
          pt.y >= y &&
          pt.x <= x + width &&
          pt.y <= y + height
        ) {
          selected.push([cornerIdx, idx]);
        }
      });
    });

    this.selected = selected;
    this.setPoints(getPoints(this.shape));
  }

  finishBoxSelection = () => {
    if (this.selectionBox?.parentNode) {
      this.selectionBox.parentNode.removeChild(this.selectionBox);
    }

    this.selectionBox = null;
    this.selectionStart = null;

    document.removeEventListener('mousemove', this.onDocumentMouseMove, true);
    document.removeEventListener('mouseup', this.onDocumentMouseUp, true);
    document.removeEventListener('pointermove', this.onDocumentPointerMove, true);
    document.removeEventListener('pointerup', this.onDocumentPointerUp, true);
    // Fokus auf ersten selektierten Punkt
    try{
      if (this.selected.length > 0) {
        const [polyIdx, pointIdx] = this.selected[0];
        const handle = this.cornerHandles?.[polyIdx]?.[pointIdx];

        if (handle) {
          handle.setAttribute('tabindex', '0');
          handle.focus();
        }
      }

    } catch (e) {
      console.log(e)
    }
  }

  onDocumentMouseMove = evt => {
    if (!this.selectionBox)
      return;

    this.stopOSDDrag(evt);
    this.updateBoxSelection(this.getEventSVGPoint(evt));
  }

  onDocumentMouseUp = evt => {
    if (!this.selectionBox)
      return;

    this.stopOSDDrag(evt);
    this.finishBoxSelection();
  }

  onDocumentPointerMove = evt => {
    if (!this.selectionBox)
      return;

    this.stopOSDDrag(evt);
    this.updateBoxSelection(this.getEventSVGPoint(evt));
  }

  onDocumentPointerUp = evt => {
    if (!this.selectionBox)
      return;

    this.stopOSDDrag(evt);
    this.finishBoxSelection();
  }

  onMoveShape = pos => {
    const constrain = (coord, delta, max) =>
      coord + delta < 0 ? -coord : (coord + delta > max ? max - coord : delta);
    const { x, y, width, height } = getBBox(this.shape);
    const { naturalWidth, naturalHeight } = this.env.image;

    const dx = constrain(x, pos.x - this.grabbedAt.x, naturalWidth - width);
    const dy = constrain(y, pos.y - this.grabbedAt.y, naturalHeight - height);
    let updatedPoints = []
    for (let pointlist of getPoints(this.shape)){
      let newPointList = pointlist.map(pt => ([ pt.x , pt.y ]))
      if (pointInPolygon([this.grabbedAt.x,this.grabbedAt.y], newPointList)){
        updatedPoints.push(pointlist.map(pt =>
          ({ x: pt.x + dx, y: pt.y + dy })))
      } else {
        updatedPoints.push(pointlist)
      }
    }
    this.grabbedAt = pos;

    // Update shape
    this.setPoints(updatedPoints);
  }

  onMoveCornerHandle = (pos, evt) => {
    let handleIdx = -1
    let cornerHandleIdx = 0
    for (let cornerHandle of this.cornerHandles){
      handleIdx = cornerHandle.indexOf(this.grabbedElement);
      if (handleIdx > -1){
        break
      } else {
        cornerHandleIdx += 1
      }
    }

    // Update selection
    if (evt.ctrlKey) {
      this.selected = Array.from(new Set([...this.selected, handleIdx]));
    } else if (!this.selected.includes(handleIdx)) {
      this.selected = [ handleIdx ];
    }

    // Compute offsets between selected points from current selected
    const points = getPoints(this.shape);

    const distances = this.selected.map(idx => {
      const handleXY = points[cornerHandleIdx][handleIdx];
      const thisXY = points[cornerHandleIdx][idx];

      return {
        index: idx,
        dx: thisXY.x - handleXY.x,
        dy: thisXY.y - handleXY.y
      }
    });
    let cornerHandleIdxUpdate = 0
    let updatedPoints = []
    for (let points of getPoints(this.shape)){
      if (cornerHandleIdxUpdate === cornerHandleIdx){
        let updatedPointList = points.map((pt, idx) => {
          if (idx === handleIdx) {
            // The dragged point
            return pos;
          } else if (this.selected.includes(idx)) {
            const { dx, dy } = distances.find(d => d.index === idx);
            return {
              x: pos.x + dx,
              y: pos.y + dy
            }
          } else {
            // Unchanged
            return pt;
          }
        });
        updatedPoints.push(updatedPointList);
      } else {
        updatedPoints.push(points)
      }
      cornerHandleIdxUpdate += 1
    }
    this.setPoints(updatedPoints);
  }

  onMouseMove = evt => {
    if (this.selectionBox) {
      this.stopOSDDrag(evt);
      this.updateBoxSelection(this.getEventSVGPoint(evt));
      return;
    }

    if (this.grabbedElement) {
      const pos = this.getSVGPoint(evt);
      if (this.grabbedElement === this.shape) {
        this.onMoveShape(pos);
      } else if (hasClass(this.grabbedElement, 'a9s-handle')) {
        this.onMoveCornerHandle(pos, evt);
      } else if (hasClass(this.grabbedElement, 'a9s-midpoint')) {
        this.onAddPoint(pos);
      }
      console.log("update", this.shape, this.env.image);
      this.emit('update', toSVGTarget(getPoints(this.shape), this.env.image));
    }
  }

  onMouseUp = evt => {
    if (this.selectionBox) {
      this.stopOSDDrag(evt);
      this.finishBoxSelection();
      return;
    }

    this.grabbedElement = null;
    this.grabbedAt = null;
  }

  onScaleChanged = scale => {
    console.log("onScaleChanged editable", scale);

    for (let cornerHandle of this.cornerHandles){
      cornerHandle.map(this.scaleHandle);
    }
    for (let midpoints of this.midpoints){
      midpoints.map(midpoint => {
        midpoint.setAttribute('r', 5 * this.scale);
      });
    }
  }

  onSelectCorner = handle => evt => {
    const isDrag = new Date().getTime() - this.lastMouseDown > 250;

    if (!isDrag) {
      let cornerhandlesIDX = -1
      let idx = -1
      for (let corners of this.cornerHandles){
        cornerhandlesIDX += 1
        idx = corners.indexOf(handle);
        if (idx > 0) break
      }

      if (evt?.ctrlKey) {
        // Toggle
        if ( this.selected.map(object => (object[0] === cornerhandlesIDX && object[1] === idx)).indexOf(true) > -1) {
          this.selected = this.selected.filter(i => {
            return !(i[1] === idx && i[0] === cornerhandlesIDX)
          });
        } else
          this.selected = [...this.selected, [cornerhandlesIDX, idx]];
      } else {
        if (this.selected.length === 1 && (this.selected[0][1] === idx && this.selected[0][0] === cornerhandlesIDX)) {
          this.selected = [];
        } else {
          this.selected = [[cornerhandlesIDX, idx ]];
        }
      }

      this.setPoints(getPoints(this.shape));
    }
    handle.focus();
  }

  setPoints = points => {
    // Not using .toFixed(1) because that will ALWAYS
    // Set polygon points
    const str = getPath(points);
    const inner = this.shape.querySelector('.a9s-inner');
    inner.setAttribute('d', str);

    const outer = this.shape.querySelector('.a9s-outer');
    outer.setAttribute('d', str);

    // Corner handles
    let cornerIdx = 0
    for (let pointList of points){

      pointList.forEach((pt, idx) => {
        this.setHandleXY(this.cornerHandles[cornerIdx][idx], pt.x, pt.y)
      });
    // Midpoints
      for (let idx=0; idx<pointList.length; idx++) {
        const thisCorner = pointList[idx];
        const nextCorner = idx === pointList.length - 1 ? pointList[0] : pointList[idx + 1];
        const x = (thisCorner.x + nextCorner.x) / 2;
        const y = (thisCorner.y + nextCorner.y) / 2;

        const handle = this.midpoints[cornerIdx][idx];
        handle.setAttribute('cx', x);
        handle.setAttribute('cy', y);
      }
        cornerIdx +=1
    }
    let cornerHandleIdx = -1
    for (let corners of this.cornerHandles){
      cornerHandleIdx += 1

      corners.forEach((handle, i) => {

        const isSelected = this.selected.map(object => (object[0] === cornerHandleIdx && object[1] === i)).indexOf(true) > -1;
        if (isSelected && !hasClass(handle, 'selectedCorner')) {
          addClass(handle, 'selectedCorner');
        } else if (!isSelected && hasClass(handle, 'selectedCorner')) {
          removeClass(handle, 'selectedCorner');
        }
      });
    }

    // Resize formatter elements
    const { x, y, width, height } = outer.getBBox();
    setFormatterElSize(this.shape, x, y, width, height);
  }

  updateState = annotation => {
    const shape = drawEmbeddedSVG(annotation);
    const points = getPoints(shape);
    this.setPoints(points);
    this.annotation = annotation;
  }

}
